import { AxiosInstance, AxiosResponse } from "axios";

export abstract class Api {
  protected baseUrl: string;
  protected axios: AxiosInstance;

  protected constructor(baseUrl: string, axios: AxiosInstance) {
    this.baseUrl = baseUrl;
    this.axios = axios;
  }

  public params(params: Record<string, any> | null): string {
    let query = "";
    if (params) {
      for (const param in params) {
        query += `${param}=${params[param]}`;
      }
    }
    return query;
  }

  public async form<FM>(
    TypeCreator: new () => FM,
    params: Record<string, any> | null
  ): Promise<FM> {
    if (params === null) {
      return new TypeCreator();
    }
    const query = this.params(params);
    const url = query ? `${this.baseUrl}/fm?${query}` : `${this.baseUrl}/fm`;
    const response: AxiosResponse = await this.axios.get<FM>(url);
    return response.data;
  }

  public async autocomplete<AM>(search: string, params: Record<string, any>): Promise<AM[]> {
    const query = this.params(params);
    const url =
      search !== null && search !== undefined && search !== ""
        ? `${this.baseUrl}/autocomplete?search=${search}&${query}`
        : `${this.baseUrl}/autocomplete?${query}`;
    const response: AxiosResponse<AM[]> = await this.axios.get<AM[]>(url);
    return response.data;
  }

  public async create<C, M>(command: C): Promise<M> {
    const response: AxiosResponse = await this.axios.post<M>(this.baseUrl, command);
    return response.data;
  }

  public async update<C, M>(command: C): Promise<M> {
    const response: AxiosResponse = await this.axios.put(this.baseUrl, command);
    return response.data;
  }

  public async delete(id: number): Promise<AxiosResponse> {
    const response: AxiosResponse = await this.axios.delete(this.baseUrl + `?id=${id}`);
    return response;
  }

  public async findPage<M>(queryParam: string): Promise<AxiosResponse> {
    const response: AxiosResponse = await this.axios.get(this.baseUrl + "/p?" + queryParam);
    return response;
  }

  public async deactivate(id: number): Promise<AxiosResponse> {
    const response: AxiosResponse = await this.axios.put(`${this.baseUrl}/deactivate?`, { id });
    return response;
  }

  public async show(id: number): Promise<AxiosResponse> {
    const query: string = this.params({ id: id });
    const response: AxiosResponse = await this.axios.get(this.baseUrl + `/sh?${query}`);
    return response;
  }
}
